(function () {
  'use strict';
  function init() {
    var directory = document.querySelector('#bhoRetailDirectory');
    if (!directory) return;
    var input = directory.querySelector('#searchInput');
    var host = directory.querySelector('#mobileRegionAccordion');
    if (!input || !host) return;
    var status = document.createElement('p');
    status.className = 'bho-retail-search-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    host.before(status);
    var saved = null;
    function update() {
      var query = input.value.toLowerCase().trim();
      var items = Array.from(host.querySelectorAll('details.mobile-region-item'));
      var english = document.documentElement.dataset.bhoLanguage === 'en';
      if (query && !saved) saved = new Map(items.map(function (item) { return [item, item.open]; }));
      var total = 0;
      items.forEach(function (item) {
        var cards = Array.from(item.querySelectorAll('.location-card'));
        var count = cards.filter(function (card) { return !query || (card.dataset.name || '').includes(query) || (card.dataset.address || '').includes(query); }).length;
        total += count;
        item.hidden = Boolean(query && !count);
        if (query) item.open = count > 0;
        else if (saved) item.open = saved.get(item) || false;
        var badge = item.querySelector('.mobile-region-count');
        if (badge) badge.textContent = String(count) + (english ? '' : '家');
      });
      status.hidden = !query;
      status.textContent = total ? (english ? total + ' matching locations. Results are expanded below.' : '找到 ' + total + ' 家分销处，已展开搜索结果。') : (english ? 'No matching locations. Try a store name, street or postal code.' : '没有找到相符的分销处。请试试店名、街道或邮编。');
      if (!query) saved = null;
    }
    input.addEventListener('input', update);
    directory.querySelectorAll('.tab-btn').forEach(function (button) { button.addEventListener('click', update); });
    document.addEventListener('bho:languagechange', update);
    new MutationObserver(update).observe(document.documentElement, {attributes:true,attributeFilter:['data-bho-language']});
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());
